import React from 'react';

type FallbackComponentProps = {
  error: Error;
  resetErrorBoundary: () => void;
};

const FallbackComponent = (props: FallbackComponentProps) => {
  const { error, resetErrorBoundary } = props;
  return (
    <div>
      <p>An error occurred: {error.message}</p>
      <button onClick={resetErrorBoundary}>Try again</button>
    </div>
  );
};

export default FallbackComponent;
